
import React, { useState } from 'react';
import { useTeamManagement } from '@/hooks/useTeamManagement';
import { TeamDialog } from './TeamDialog';
import { TeamCard } from './TeamCard';

interface TeamManagementProps {
  clubId?: string;
  organizationId?: string;
}

export const TeamManagement = ({ clubId, organizationId }: TeamManagementProps) => {
  const [hoveredTeamId, setHoveredTeamId] = useState<string | null>(null);
  
  const {
    teams,
    clubCoaches,
    loading,
    isDialogOpen,
    setIsDialogOpen,
    editingTeam,
    teamName,
    setTeamName,
    selectedClubId,
    setSelectedClubId,
    selectedSeasonId,
    setSelectedSeasonId,
    selectedCoachId,
    setSelectedCoachId,
    selectedDivisionId,
    setSelectedDivisionId,
    isSubmitting,
    validationErrors,
    handleSubmit,
    handleDialogClose
  } = useTeamManagement(clubId);

  if (loading) {
    return <div>Loading teams...</div>;
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <div>
          <h3 className="text-lg font-semibold">Teams</h3>
          <p className="text-sm text-muted-foreground">
            {clubId ? 'Manage teams for this club' : 'Manage teams across your clubs and seasons'}
          </p>
        </div>
        <TeamDialog
          isOpen={isDialogOpen}
          onOpenChange={setIsDialogOpen}
          editingTeam={editingTeam}
          teamName={teamName}
          setTeamName={setTeamName}
          selectedClubId={selectedClubId}
          setSelectedClubId={setSelectedClubId}
          selectedSeasonId={selectedSeasonId}
          setSelectedSeasonId={setSelectedSeasonId}
          selectedCoachId={selectedCoachId}
          setSelectedCoachId={setSelectedCoachId}
          selectedDivisionId={selectedDivisionId}
          setSelectedDivisionId={setSelectedDivisionId}
          clubCoaches={clubCoaches}
          isSubmitting={isSubmitting}
          validationErrors={validationErrors}
          onSubmit={handleSubmit}
          onClose={handleDialogClose}
          organizationId={organizationId}
        />
      </div>

      {teams.length === 0 ? (
        <div className="text-center text-muted-foreground py-8">
          <p>No teams found. Create your first team to get started!</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {teams.map((team) => (
            <TeamCard
              key={team.id}
              team={team}
              hoveredTeamId={hoveredTeamId}
              onMouseEnter={() => setHoveredTeamId(team.id)}
              onMouseLeave={() => setHoveredTeamId(null)}
            />
          ))}
        </div>
      )}
    </div>
  );
};
